import { lsGetSelectedCommonFilters } from 'helpers/store';
import { fetchFromObject } from 'helpers/object';

export default {
  dataUI: state => field => fetchFromObject(state, field),
  hasMasterData: state =>
    !!state.StreetType &&
    !!state.MaritalStatus &&
    !!state.Profession &&
    !!state.Sex &&
    !!state.SignType,
  paginationFilters: state => section => state.paginationFilters[section],
  commonFilters: state => filter =>
    state.commonFilters[filter] || lsGetSelectedCommonFilters(filter)
};
